import React, { Component } from 'react'
import '../../../style.css'
import { Row, Table, Tag, Button, Tooltip, Modal } from 'antd'
import Axios from '../../../config/axios'
import searchColumns from '../../../helpers/searchColumns'
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom'
import Loading from '../../../components/Loading'
import withErrorHandler from '../../../hoc/withErrorHandler'

class Letter extends Component {

    state = {
        letters : [],
        page: 1,
        pageSize: 10, 
        pagination : {},
        searchText : '',
        searchedColumn: '',   
    }

    componentDidMount() {
        this.fetchLetters()               
    }

    fetchLetters = (filters = {}, sorter = {}) => {

        let params = {}
        if(filters.title) params.title = filters.title[0]
        if(filters.type) params.type  =filters.type[0]  
        if(sorter.field && sorter.order) {
            params.sort_field = sorter.field
            params.sort_order = sorter.order === "ascend" ? 1 : -1
        }           
        Axios.get("/letters", {
            params : {
                page: this.state.page,
                page_size: this.state.pageSize,
                ...params                
            }
        }).then(response => {              
            let { pagination } = this.state
            pagination.total = response.data.total 
            pagination.pageSize = this.state.pageSize         
            this.setState({ letters : response.data.payload, pagination })
        })
    }

    handleChangeTable = (pagination, filters, sorter) => {        
        const pager = { ...this.state.pagination };
        pager.current = pagination.current;
        this.setState({
          pagination: pager,
          page: pager.current,          
        }, () => {
            this.fetchLetters(filters, sorter)
        });


    }

    handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        this.setState({
          searchText: selectedKeys[0],
          searchedColumn: dataIndex,
        });
    };
    
    handleReset = clearFilters => {
        clearFilters();
        this.setState({ searchText: '' });
    };

    handleDelete = (record) => {
        Axios.delete("/letters/delete/"+record._id).then(() => {
            this.fetchLetters()
        })
    }

    confirmModal = (record) => {
        Modal.confirm({
            title: 'Hapus Surat',
            content: 'Apakah Anda yakin ingin mengapus '+record.title,  
            onOk: () => this.handleDelete(record),  
            oncancel: {}      
          });
    }

    render() {
        
        const columns = [            
            {
                title: 'Nama Surat',
                dataIndex: 'title',
                sorter: true,
                ...searchColumns('title', this.handleSearch, this.handleReset, this.state.searchedColumn, this.state.searchText)                                 
            },
            {
                title: 'Jenis Surat',
                dataIndex: 'type',
                sorter: true,
                filters: [                   
                    { text: 'Akademik', value: 'akademik' },
                    { text: 'Kemahasiswaan', value: 'kemahasiswaan' },                    
                ],  
                filterMultiple: false,
                render: type => {
                    const colors = {                
                        akademik : 'blue',
                        kemahasiswaan : 'green',                    
                    }        
                    return <Tag color={colors[type]}>{type.toUpperCase()}</Tag> 
                }  
            } ,
            {
                title: '',          
                render: record =>
                <>                
                  <Tooltip title="kode surat" className="m-2">
                    <Link to={"/admin/master-surat/kode-surat/"+record._id}>
                    <Button shape="circle"><EditOutlined /></Button>
                    </Link>
                  </Tooltip> 
                  <Tooltip title="Update" className="m-2">
                    <Link to={"/admin/master-surat/manage/"+record._id}>
                    <Button shape="circle" type="primary"><EditOutlined /></Button>
                    </Link>
                  </Tooltip>            
                  <Tooltip title="Delete" className="m-2">
                    <Button shape="circle" type="danger" onClick={() => this.confirmModal(record)}><DeleteOutlined /></Button>
                  </Tooltip>
                </>
            }       
        ]

        return(
            <>          
                <Row style={{padding:10}}>
                    <Link to="/admin/master-surat/manage">
                        <Button 
                            shape="round" 
                            style={{marginBottom:15}} 
                            className="add-button"                        
                        >
                            <PlusOutlined />Tambah Surat
                        </Button>
                    </Link>   
                    <Table
                        style={{width:'100%'}}
                        rowKey = "_id"
                        columns={columns}                      
                        dataSource={this.state.letters}                     
                        loading={this.props.loading}
                        pagination={this.state.pagination}
                        onChange={this.handleChangeTable}
                    />
                </Row>                
                <Loading loading={this.props.loading} /> 
            </>
        )
    }
}

export default withErrorHandler(Letter, Axios)